import React from "react";
import { Card, Typography, Divider, Space, Tag } from "antd";
import { MailOutlined, UserOutlined, CopyOutlined } from "@ant-design/icons";
// import { prepareHtmlForPreview } from "../utils/htmlCleanup"; // 不再需要，因为contentHtml已经是处理过的
import "./EmailPreview.css";

const { Title, Text } = Typography;

/**
 * 邮件预览组件
 * 显示邮件的最终效果，包括收件人信息和渲染后的内容
 */
const EmailPreview = ({ 
    subject = "", 
    recipients = {}, 
    contentHtml = "", 
    attachments = [] 
}) => {
    const { to = "", cc = "", bcc = "" } = recipients;

    // 解析收件人列表
    const parseRecipients = (recipientData) => {
        if (!recipientData) return [];
        
        // 如果是数组，直接返回
        if (Array.isArray(recipientData)) {
            return recipientData.filter(Boolean);
        }
        
        // 如果是字符串，按分隔符分割
        if (typeof recipientData === 'string') {
            return recipientData.split(/[,;]/).map(email => email.trim()).filter(Boolean);
        }
        
        // 其他情况返回空数组
        return [];
    };

    const toList = parseRecipients(to);
    const ccList = parseRecipients(cc);
    const bccList = parseRecipients(bcc);

    return (
        <div className="email-preview-container">
            <Card className="email-preview-card" bordered={false}>
                {/* 邮件头部信息 */}
                <div className="email-header">
                    <div className="email-header-row">
                        <Text strong style={{ minWidth: "60px", color: "#666" }}>主题:</Text>
                        <Title level={4} style={{ margin: 0, color: "#333" }}>
                            {subject || "无主题"}
                        </Title>
                    </div>

                    <Divider style={{ margin: "12px 0" }} />

                    <div className="email-recipients">
                        {toList.length > 0 && (
                            <div className="email-header-row">
                                <Text strong style={{ minWidth: "60px", color: "#666" }}>收件人:</Text>
                                <Space wrap>
                                    {toList.map((email, index) => (
                                        <Tag key={index} icon={<UserOutlined />} color="blue">
                                            {email}
                                        </Tag>
                                    ))}
                                </Space>
                            </div>
                        )}

                        {ccList.length > 0 && (
                            <div className="email-header-row">
                                <Text strong style={{ minWidth: "60px", color: "#666" }}>抄送:</Text>
                                <Space wrap>
                                    {ccList.map((email, index) => (
                                        <Tag key={index} icon={<CopyOutlined />} color="cyan">
                                            {email}
                                        </Tag>
                                    ))}
                                </Space>
                            </div>
                        )}

                        {bccList.length > 0 && (
                            <div className="email-header-row">
                                <Text strong style={{ minWidth: "60px", color: "#666" }}>密送:</Text>
                                <Space wrap>
                                    {bccList.map((email, index) => (
                                        <Tag key={index} icon={<CopyOutlined />} color="purple">
                                            {email}
                                        </Tag>
                                    ))}
                                </Space>
                            </div>
                        )}

                        {attachments.length > 0 && (
                            <div className="email-header-row">
                                <Text strong style={{ minWidth: "60px", color: "#666" }}>附件:</Text>
                                <Space wrap>
                                    {attachments.map((attachment, index) => (
                                        <Tag key={index} icon={<MailOutlined />} color="orange">
                                            {attachment.filename || attachment.name || `附件 ${index + 1}`}
                                        </Tag>
                                    ))}
                                </Space>
                            </div>
                        )}
                    </div>

                    <Divider style={{ margin: "16px 0" }} />
                </div>

                {/* 邮件正文内容 */}
                <div className="email-body">
                    <div 
                        className="email-content"
                        dangerouslySetInnerHTML={{ __html: contentHtml }}
                        style={{
                            minHeight: "200px",
                            padding: "16px",
                            backgroundColor: "#fafafa",
                            borderRadius: "6px",
                            border: "1px solid #f0f0f0",
                            fontSize: "14px",
                            lineHeight: "1.6",
                            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
                        }}
                    />
                </div>
            </Card>
        </div>
    );
};

export default EmailPreview; 